const palette = [
  { color: '#fcdf86', label: '1PN', id: 'studio' },
  { color: '#5b5454', label: '1PN', id: '1pn' },
  { color: '#d7552c', label: '1PN+', id: '1pn-plus' },
  { color: '#b8943d', label: '2PN', id: '2pn-1wc' },
  { color: '#99d2c9', label: '2PN+', id: '2pn-2wc' },
  { color: '#f9bd9c', label: '3PN', id: '3pn' },
  { color: '#d0072e', label: '3PN+', id: '3pn-dualkey' },
];

export const FloorPalette = () => {
  return (
    <div className="floor-palette">
      <div className="palette-container">
        {palette.map((item) => (
          <div className="palette-item" key={item.id}>
            <div
              className="color-box"
              style={{ backgroundColor: item.color }}
            ></div>
            <span className="label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
